import {
	BREAKDOWN_FILTER_OPTIONS,
	getDateFormat,
	getDateRangeMonthYearState,
} from 'Benchmarks/utils';
import React, { createContext, useEffect, useState } from 'react';
import {
	getActualSavings,
	getAIValueTool,
	getAveragePO,
	getAvgCompPerFte,
	getAvgSourcingHCRoi,
	getAvgSpendPerBuyer,
	getBreakDownFilterForPareto,
	getBuyersOperationalProcurementFTEsInBestCostCountry,
	getCLMTools,
	getDateRangeProcurementMetrics,
	getFTESSupportingStrategicActivities,
	getIndirectSpend,
	getParetoCatrgoryData,
	getProcurementOrgStructure,
	getProcurementReportingData,
	getProcurementResponsibilities,
	getPTPTools,
	getSpendAnalyticsTool,
	getSpendPerProcurementFTE,
	getTouchlessPO,
	getWtAvgPaymentTerm,
} from 'utils/apiRequests';

export const procurementMetricsContext = createContext();

function ProcurementMetricsContextProvider(props) {
	const { activeTabId } = props;
	const [industries, setIndustries] = useState([]);
	const [regions, setRegions] = useState([]);
	const [applyFilter, setApplyFilter] = useState(false);
	const [dateRangeData, setDateRangeData] = useState({
		srcRange: {
			from: { year: 2022, month: 10 },
			to: { year: 2023, month: 9 },
		},
		stateRange: {
			from: {
				month: 'oct',
				monthNumber: 10,
				year: 2022,
			},
			to: {
				month: 'sep',
				monthNumber: 9,
				year: 2023,
			},
		},
		dateFrom: '2023-10-01',
		dateTo: '2023-09-31',
	});

	const [defaultDateRange, setDefaultDateRange] = useState({
		srcRange: {
			from: { year: 2022, month: 10 },
			to: { year: 2023, month: 9 },
		},
		stateRange: {
			from: {
				month: 'oct',
				monthNumber: 10,
				year: 2022,
			},
			to: {
				month: 'sep',
				monthNumber: 9,
				year: 2023,
			},
		},
		dateFrom: '2023-10-01',
		dateTo: '2023-09-31',
	});

	const [
		procurementMetricsNumericalData,
		setProcurementMetricsNumericalData,
	] = useState([
		// {
		// 	id: '79f77ff6-9a6d-4dc5-8b55-80a2f87805dc',
		// 	qmin: 52977151.369565,
		// 	qmax: 52977151.369565,
		// 	qmedian: 52977151.369565,
		// 	name: 'Total',
		// 	parent: 'Total',
		// 	level: 1,
		// 	group: 1,
		// 	clientTotalMarker: 361602518.8595,
		// 	showFormattedSpend: true,
		// 	children: [
		// 		{
		// 			id: '26fe863f-9d6f-4d55-871a-e7e0ec9b3fed',
		// 			qmin: 152309310.1875,
		// 			qmax: 192309310.1875,
		// 			qmedian: 162309310.1875,
		// 			clientDirectMarker: 172309310.1818181,
		// 			name: 'Direct',
		// 			parent: 'Total',
		// 			level: 2,
		// 			group: 1,
		// 			showFormattedSpend: true,
		// 			// children: [],
		// 		},
		// 		{
		// 			id: 'ca4b711c-cbf8-4453-836e-cda3e71745ce',
		// 			qmin: 152309310.1875,
		// 			qmax: 152309310.1875,
		// 			qmedian: 152309310.1875,
		// 			name: 'Indirect',
		// 			parent: 'Total',
		// 			level: 2,
		// 			group: 1,
		// 			// children: [],
		// 			clientIndirectMarker: 613019688.1818181,
		// 			showFormattedSpend: true,
		// 		},
		// 	],
		// },
	]);
	const [tab2Data, setTab2Data] = useState([]);
	const [loading, setLoading] = useState(true);
	const [loadingTab2, setLoadingTab2] = useState(true);
	const [hierarchyData, setHierarchyData] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const [isDateAvailabe, setIsDateAvailable] = useState(false);
	const [payload, setPayload] = useState({
		flag: 0,
		Industry: [],
		Regions: [],
		Dimension: 'AP_L1Category',
		Values: [],
		dateFrom: '2023-01-01',
		dateTo: '2024-12-31',
	});

	const [
		currentBreakDownFilterCategory,
		setCurrentBreakDownFilterCategory,
	] = useState(BREAKDOWN_FILTER_OPTIONS[0]);

	const [currentFilterOptions, setcurrentFilterOptions] = useState([]);

	const [
		currentFilterValuesSelectedCategory,
		setcurrentFilterValuesSelectedCategory,
	] = useState([]);

	const [
		currentFilterOptionsCategory,
		setcurrentFilterOptionsCategory,
	] = useState([]);

	const getBreakDownFilter = async value => {
		const payload = { dimension: value };
		const response = await getBreakDownFilterForPareto(payload);
		if (response.succeeded) {
			setcurrentFilterOptionsCategory(
				response.data.map(data => ({ label: data, value: data }))
			);
		}
	};

	const handleFilterByChangeCategory = e => {
		setCurrentBreakDownFilterCategory(e);
		getBreakDownFilter(e.value, true);

		setcurrentFilterValuesSelectedCategory([]);
	};

	const onChangeIndustry = e => {
		setIndustries(e);
		// setPayload({ ...payload, Industry: e });
	};

	const onChangeRegion = e => {
		setRegions(e);
		// setPayload({ ...payload, Regions: e });
	};

	const onChangeDateRange = value => {
		const minMaxDates = getDateFormat(value);
		setDateRangeData(prevState => ({
			...prevState,
			stateRange: value,
			...minMaxDates,
		}));
	};
	useEffect(() => {
		getBreakDownFilter(currentBreakDownFilterCategory.value);
		getDateRangeProcurementMetrics()
			.then(res => {
				const { from, to } = res.data.srcRange;
				const dateFrom = `${from.year}-${String(from.month).padStart(
					2,
					'0'
				)}-01`;
				const lastDay = new Date(to.year, to.month, 0).getDate();
				const dateTo = `${to.year}-${String(to.month).padStart(
					2,
					'0'
				)}-${String(lastDay).padStart(2, '0')}`;

				const selectedRange = getDateRangeMonthYearState(dateFrom, dateTo);
				const finalRange = {
					srcRange: res.data.srcRange,
					stateRange: selectedRange,
					dateFrom,
					dateTo,
				};

				setDefaultDateRange(finalRange);
				setDateRangeData(finalRange);

				setIsDateAvailable(true);
			})
			.catch(error => console.log(error));
	}, []);

	useEffect(
		() => {
			////for first tab
			if (
				activeTabId === 0 &&
				procurementMetricsNumericalData.length === 0 &&
				isDateAvailabe
			) {
				// function structuredMetricObject(
				// 	obj,
				// 	name,
				// 	hideGradient,
				// 	showFormattedSpend,
				// 	hideBorderBottom,
				// 	showDirectIndirectSeperately
				// ) {
				// 	let res = {
				// 		clientSpendDirect: obj.data?.clientDirectMarker,
				// 		clientSpendIndirect: obj.data?.clientIndirectMarker,
				// 		clientSpend: obj.data?.clientTotalMarker,
				// 		max: obj.data?.qmax,
				// 		median: obj.data?.qmedian,
				// 		min: obj.data?.qmin,
				// 		name: name,
				// 		isDataAvailable: obj.data ? true : false,
				// 		hideGradient: hideGradient,
				// 		showFormattedSpend: showFormattedSpend,
				// 		hideBorderBottom: hideBorderBottom,
				// 		showDirectIndirectSeperately: showDirectIndirectSeperately,
				// 	};
				// 	return res;
				// }

				function structuredMetricObject1(
					obj,
					name,
					hideGradient,
					showFormattedSpend,
					// hideBorderBottom,
					// showDirectIndirectSeperately,
					convertIntoPercentage,
					unit = ''
				) {
					if (obj.data?.length > 0) {
						let isTotalPresent = obj.data.some(item => item.name === 'total');
						let tempObj = {
							id: name,
							qmin: null,
							qmax: null,
							qmedian: null,
							name: name,
							parent: 'Total',
							level: 1,
							group: 1,
							clientTotalMarker: null,
							children: [],
							isDataAvailable: obj.data ? true : false,
							hideGradient: hideGradient,
							showFormattedSpend: showFormattedSpend,
							hideChart: !isTotalPresent,
							isExpanded: !isTotalPresent,
							unit: unit,
							// hideBorderBottom: hideBorderBottom,
							// showDirectIndirectSeperately: showDirectIndirectSeperately,
						};

						obj.data.forEach(item => {
							if (item.name === 'total') {
								tempObj.id = item.id;
								tempObj.qmin = item.qmin;
								// tempObj.qmin = convertIntoPercentage
								// 	? item.qmin * 100
								// 	: item.qmin;
								tempObj.qmax = item.qmax;
								// tempObj.qmax = convertIntoPercentage
								// 	? item.qmax * 100
								// 	: item.qmax;
								tempObj.qmedian = item.qmedian;
								// tempObj.qmedian = convertIntoPercentage
								// 	? item.qmedian * 100
								// 	: item.qmedian;
								tempObj.parent = 'Total';
								tempObj.level = 1;
								tempObj.group = 1;
								tempObj.clientTotalMarker = convertIntoPercentage
									? item.clientMarker * 100
									: item.clientMarker;
							}
							if (item.name === 'direct' || item.name === 'indirect') {
								let obj = {
									id: item.id,
									// qmin: convertIntoPercentage ? item.qmin * 100 : item.qmin,
									qmin: item.qmin,
									// qmax: convertIntoPercentage ? item.qmax * 100 : item.qmax,
									qmax: item.qmax,
									qmedian: item.qmedian,
									// qmedian: convertIntoPercentage
									// 	? item.qmedian * 100
									// 	: item.qmedian,
									name:
										item.name?.charAt(0)?.toUpperCase() + item.name?.slice(1),
									parent: 'Total',
									level: 2,
									group: 1,
									hideGradient: hideGradient,
									showFormattedSpend: showFormattedSpend,
									unit: unit,
								};
								if (item.name === 'direct') {
									obj.clientDirectMarker = convertIntoPercentage
										? item.clientMarker * 100
										: item.clientMarker;
								} else {
									obj.clientIndirectMarker = convertIntoPercentage
										? item.clientMarker * 100
										: item.clientMarker;
								}
								tempObj.children.push(obj);
							}
						});
						return tempObj;
					} else {
						let res = {
							clientSpendDirect: obj.data?.clientDirectMarker,
							clientSpendIndirect: obj.data?.clientIndirectMarker,
							clientSpend: obj.data?.clientTotalMarker,
							max: obj.data?.qmax,
							median: obj.data?.qmedian,
							min: obj.data?.qmin,
							name: name,
							isDataAvailable: obj.data ? true : false,
							hideGradient: hideGradient,
							showFormattedSpend: showFormattedSpend,
							// hideBorderBottom: hideBorderBottom,
							// showDirectIndirectSeperately: showDirectIndirectSeperately,
						};
						return res;
					}
				}
				async function fetchData() {
					try {
						setLoading(true);
						let payload = {
							Industry: industries,
							Regions: regions,
							dateFrom: dateRangeData.dateFrom,
							dateTo: dateRangeData.dateTo,
						};

						let spendPerProcurementFTE = await getSpendPerProcurementFTE(
							payload
						);

						setProcurementMetricsNumericalData(prev => [
							...prev,
							structuredMetricObject1(
								spendPerProcurementFTE,
								'Spend per procurement FTE',
								true,
								true
							),
						]);
						let AvgSpendPerBuyer = await getAvgSpendPerBuyer(payload);
						setProcurementMetricsNumericalData(prev => [
							...prev,
							structuredMetricObject1(
								AvgSpendPerBuyer,
								'Average spend per buyer',
								true,
								true
							),
						]);
						let buyersOperationalProcurementFTEsInBestCostCountry = await getBuyersOperationalProcurementFTEsInBestCostCountry(
							payload
						);
						setProcurementMetricsNumericalData(prev => [
							...prev,
							structuredMetricObject1(
								buyersOperationalProcurementFTEsInBestCostCountry,
								'Procurement FTE in best cost country',
								false,
								false,
								false,
								'%'
							),
						]);

						let FTESSupportingSTrategicActivities = await getFTESSupportingStrategicActivities(
							payload
						);
						setProcurementMetricsNumericalData(prev => [
							...prev,
							structuredMetricObject1(
								FTESSupportingSTrategicActivities,
								'% of FTEs supporting strategic activities in procurement',
								true,
								false,
								true,
								'%'
							),
						]);

						let avgCompPerFte = await getAvgCompPerFte(payload);
						setProcurementMetricsNumericalData(prev => [
							...prev,
							structuredMetricObject1(
								avgCompPerFte,
								'Average comp per FTE',
								true,
								true
							),
						]);
						let avgSourcingHCRoi = await getAvgSourcingHCRoi(payload);
						setProcurementMetricsNumericalData(prev => [
							...prev,
							structuredMetricObject1(
								avgSourcingHCRoi,
								'Average sourcing HC ROI',
								false,
								true
							),
						]);

						let actualSavings = await getActualSavings(payload);
						setProcurementMetricsNumericalData(prev => [
							...prev,
							structuredMetricObject1(
								actualSavings,
								'Actual savings',
								false,
								false,
								false,
								'%'
							),
						]);

						let indirectSpend = await getIndirectSpend(payload);
						setProcurementMetricsNumericalData(prev => [
							...prev,
							structuredMetricObject1(
								indirectSpend,
								'Indirect spend',
								false,
								false,
								false,
								'%'
							),
						]);
						let averagePO = await getAveragePO(payload);

						setProcurementMetricsNumericalData(prev => [
							...prev,
							structuredMetricObject1(averagePO, 'Average PO', false, true),
						]);

						let touchlessPO = await getTouchlessPO(payload);
						//numbers
						setProcurementMetricsNumericalData(prev => [
							...prev,
							structuredMetricObject1(
								touchlessPO,
								'Touchless PO',
								false,
								false,
								false,
								'%'
							),
						]);

						let wtAvgPaymentTerm = await getWtAvgPaymentTerm(payload);
						//numbers

						setProcurementMetricsNumericalData(prev => [
							...prev,
							structuredMetricObject1(
								wtAvgPaymentTerm,
								'Wt avg payment term (Days)',
								false,
								false
							),
						]);

						setLoading(false);
					} catch (error) {
						console.log(error, 'Error Message');
						setLoading(false);
					}
				}
				fetchData();
			}
		},
		[applyFilter, activeTabId, isDateAvailabe]
	);

	useEffect(
		() => {
			////for second tab
			if (activeTabId === 1 && tab2Data.length === 0 && isDateAvailabe) {
				function structuredMetricObject(val, name) {
					let res = {
						data: val,
						name: name,
					};
					return res;
				}

				async function fetchData() {
					try {
						setLoadingTab2(true);

						let payload = {
							Industry: industries,
							Regions: regions,
							dateFrom: dateRangeData.dateFrom,
							dateTo: dateRangeData.dateTo,
						};

						let procurementResponsibilities = await getProcurementResponsibilities(
							payload
						);

						setTab2Data(prev => [
							...prev,
							structuredMetricObject(
								procurementResponsibilities.data,
								'What responsibilities does procurement own?'
							),
						]);

						let procurementReporting = await getProcurementReportingData(
							payload
						);

						setTab2Data(prev => [
							...prev,
							structuredMetricObject(
								procurementReporting.data,
								'Where does procurement report into?'
							),
						]);

						let procurementOrgStructure = await getProcurementOrgStructure(
							payload
						);

						setTab2Data(prev => [
							...prev,
							structuredMetricObject(
								procurementOrgStructure.data,
								'Procurement org structure'
							),
						]);

						let ptpTools = await getPTPTools(payload);

						setTab2Data(prev => [
							...prev,
							structuredMetricObject(ptpTools.data, 'PTP tools'),
						]);

						let clmTools = await getCLMTools(payload);

						setTab2Data(prev => [
							...prev,
							structuredMetricObject(clmTools.data, 'CLM tools'),
						]);

						let spendAnalyticsTool = await getSpendAnalyticsTool(payload);

						setTab2Data(prev => [
							...prev,
							structuredMetricObject(
								spendAnalyticsTool.data,
								'Spend analytics tools'
							),
						]);

						let aiValueTool = await getAIValueTool(payload);

						setTab2Data(prev => [
							...prev,
							structuredMetricObject(aiValueTool.data, 'AI Value tools'),
						]);

						setLoadingTab2(false);
					} catch (error) {
						console.log(error, 'Error Message');
						setLoadingTab2(false);
					}
				}

				fetchData();
			}
		},
		[applyFilter, activeTabId, isDateAvailabe]
	);

	function findAndModifyData(
		arr,
		targetId,
		targetLevel,
		targetGroup,
		newChildren
	) {
		for (const obj of arr) {
			if (
				obj.name === targetId &&
				obj.level === targetLevel &&
				obj.group === targetGroup
			) {
				obj.children = newChildren;
				obj.isExpanded = true;
				return true;
			}
			if (obj.children && obj.children.length > 0) {
				if (
					findAndModifyData(
						obj.children,
						targetId,
						targetLevel,
						targetGroup,
						newChildren
					)
				) {
					return true;
				}
			}
		}
		return false;
	}

	const getParetoData = async (payload, isDrilldown = '') => {
		try {
			setIsLoading(true);
			let response = await getParetoCatrgoryData(payload);

			if (response.data?.length > 0) {
				const result = response.data.map(el => {
					return {
						...el,
						qmin:
							el.qmin <= 0.05
								? Number(el.qmin.toFixed(2))
								: Number(el.qmin.toFixed(1)),
						qmax: Number(el.qmax.toFixed(1)),
						qmedian: Number(el.qmedian.toFixed(1)),
						children: [],
						isExpanded: false,
						parent: el.parent === 'TOP' ? el.name : el.parent,
						L1Category: payload.L1Category,
						L2Category: payload.L2Category,
						L3Category: payload.L3Category,
						hideGradient: true,
						level: payload.flag + 1,
						group: payload.group || 1,
					};
				});

				if (isDrilldown) {
					const newData = hierarchyData;

					findAndModifyData(
						newData,
						payload.name,
						payload.flag,
						payload.group,
						result
					);
					setHierarchyData(newData);
				} else {
					setHierarchyData(result);
				}
			} else {
				setHierarchyData([]);
			}
			setIsLoading(false);
		} catch (error) {
			console.log(error, 'Error Message');
			setIsLoading(false);
		}
	};

	const onExpand = (categoryGroup, categoryLevel, categoryName, rowObj) => {
		let newPayload = payload;
		setIsLoading(true);
		newPayload.Dimension = currentBreakDownFilterCategory.value;
		newPayload.Values = currentFilterValuesSelectedCategory;
		newPayload.name = categoryName;
		newPayload.group = categoryGroup;
		if (categoryLevel === 1) {
			newPayload.L1Category = categoryName;
			newPayload.flag = categoryLevel;
			setPayload(prevState => ({
				...prevState,
				...newPayload,
			}));
			getParetoData(newPayload, true);
		} else if (categoryLevel === 2) {
			newPayload.L1Category = rowObj.L1Category;
			newPayload.L2Category = categoryName;
			newPayload.flag = categoryLevel;
			setPayload(prevState => ({
				...prevState,
				...newPayload,
			}));
			getParetoData(newPayload, true);
		} else if (categoryLevel === 3) {
			newPayload.L1Category = rowObj.L1Category;
			newPayload.L2Category = rowObj.L2Category;
			newPayload.L3Category = categoryName;
			newPayload.flag = categoryLevel;
			setPayload(prevState => ({
				...prevState,
				...newPayload,
			}));
			getParetoData(newPayload, true);
		} else {
			newPayload.flag = categoryLevel;
			setPayload(prevState => ({
				...prevState,
				...newPayload,
			}));
			getParetoData(newPayload, true);
		}
	};

	function updateIsExpanded(data, name, level, group, isExpanded) {
		for (const item of data) {
			if (item.name === name && item.level === level && item.group === group) {
				item.isExpanded = !isExpanded;
				return true;
			}
			if (item.children && item.children.length > 0) {
				if (updateIsExpanded(item.children, name, level, group, isExpanded)) {
					return true;
				}
			}
		}
		return false;
	}

	const onToggle = (categoryLevel, categoryName, group, expandedFlag) => {
		const newData = hierarchyData;
		updateIsExpanded(newData, categoryName, categoryLevel, group, expandedFlag);
		setHierarchyData([...newData]);
	};

	const onToggle1 = (categoryLevel, categoryName, group, expandedFlag) => {
		const newData = procurementMetricsNumericalData;
		updateIsExpanded(newData, categoryName, categoryLevel, group, expandedFlag);
		setProcurementMetricsNumericalData([...newData]);
	};

	useEffect(
		() => {
			if (
				currentBreakDownFilterCategory.value &&
				activeTabId === 0 &&
				isDateAvailabe &&
				hierarchyData.length === 0 &&
				!isLoading
			) {
				let newPayload = payload;
				newPayload.Dimension = currentBreakDownFilterCategory.value;
				newPayload.Values = currentFilterValuesSelectedCategory;
				newPayload.Industry = industries;
				newPayload.Regions = regions;
				newPayload.dateFrom = dateRangeData.dateFrom;
				newPayload.dateTo = dateRangeData.dateTo;
				newPayload.flag = 0;
				setPayload(prevState => ({
					...prevState,
					...newPayload,
				}));
				getParetoData(newPayload);
			}
		},
		[applyFilter, activeTabId, isDateAvailabe]
	);

	return (
		<procurementMetricsContext.Provider
			value={{
				industries,
				setIndustries,
				regions,
				setRegions,
				dateRangeData,
				setDateRangeData,
				onChangeIndustry,
				onChangeRegion,
				procurementMetricsNumericalData,
				setProcurementMetricsNumericalData,
				loading,
				onChangeDateRange,
				applyFilter,
				setApplyFilter,
				tab2Data,
				setTab2Data,
				loadingTab2,
				activeTabId,
				currentBreakDownFilterCategory,
				setCurrentBreakDownFilterCategory,
				currentFilterOptions,
				setcurrentFilterOptions,
				handleFilterByChangeCategory,
				currentFilterValuesSelectedCategory,
				setcurrentFilterValuesSelectedCategory,
				currentFilterOptionsCategory,
				setcurrentFilterOptionsCategory,
				hierarchyData,
				setHierarchyData,
				isLoading,
				onToggle,
				onExpand,
				defaultDateRange,
				setDefaultDateRange,
				onToggle1,
			}}
		>
			{props.children}
		</procurementMetricsContext.Provider>
	);
}

export default ProcurementMetricsContextProvider;
